import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Style/typo.css";
import "../assets/css/style-page.css";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Footer from "../../homepage/footer/Footer";

function CloudGroupware() {
    const [html, setHtml] = useState("");

    useEffect(() => {
        window.AOS = AOS;

        fetch("/software/fetch-groupware.html")
            .then((res) => res.text())
            .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                const baseUrl = "https://hanbiro.com";

                const fixUrl = (url) => {
                    if (url && !url.startsWith("http") && !url.startsWith("//") && !url.startsWith("#") && !url.startsWith("javascript:")) {
                        let cleanUrl = url.startsWith("./") ? url.substring(2) : url;
                        if (cleanUrl.startsWith("asset/image/")) {
                            return `${baseUrl}/assets/images/cloud/${cleanUrl.substring(12)}`;
                        }
                        return cleanUrl.startsWith("/") ? `${baseUrl}${cleanUrl}` : `${baseUrl}/software/${cleanUrl}`;
                    }
                    return url;
                };

                // Fix image paths
                doc.querySelectorAll("img, source").forEach((el) => {
                    const src = el.getAttribute("src");
                    if (src) el.setAttribute("src", fixUrl(src));
                    const srcset = el.getAttribute("srcset");
                    if (srcset) el.setAttribute("srcset", fixUrl(srcset));
                });

                // Fix relative background images in inline styles
                doc.querySelectorAll("[style]").forEach((el) => {
                    const style = el.getAttribute("style");
                    if (style && style.includes("url(")) {
                        const newStyle = style.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                            return `url('${fixUrl(url)}')`;
                        });
                        el.setAttribute("style", newStyle);
                    }
                });

                // Extract and inject styles
                const styles = doc.querySelectorAll("style");
                styles.forEach((oldStyle) => {
                    const newStyle = document.createElement("style");
                    newStyle.className = "fetched-style";
                    let cssContent = oldStyle.innerHTML;
                    // Fix URLs inside CSS
                    cssContent = cssContent.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                        return `url('${fixUrl(url)}')`;
                    });
                    newStyle.innerHTML = cssContent;
                    document.head.appendChild(newStyle);
                });

                // Replace FA chevron icons with inline SVG wrapped in animated span
                doc.querySelectorAll("i.sidebar-chevron").forEach((icon) => {
                    const wrapper = doc.createElement("span");
                    wrapper.innerHTML = `<span class="sidebar-chevron-wrap" style="font-size:14px;transition:transform 0.2s;display:inline-block;transform:rotate(0deg);color:rgb(153,153,153);"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3 1.2-12.7-6.4-12.7z"></path></svg></span>`;
                    icon.replaceWith(wrapper.firstChild);
                });

                const bodyContent = doc.body.innerHTML;
                setHtml(bodyContent);

                const scripts = doc.querySelectorAll("script");
                scripts.forEach((oldScript) => {
                    if (oldScript.src && oldScript.src.includes("aos")) return;

                    const newScript = document.createElement("script");
                    newScript.className = "fetched-script";
                    Array.from(oldScript.attributes).forEach((attr) =>
                        newScript.setAttribute(attr.name, attr.value)
                    );

                    let content = oldScript.innerHTML;
                    content = content.replace(/AOS\.init\(.*?\);?/g, "");

                    if (content.trim() || oldScript.src) {
                        // Wrap content in block scope to prevent redeclaration errors
                        if (content.trim()) {
                            newScript.appendChild(document.createTextNode(`{ ${content} }`));
                        }
                        document.body.appendChild(newScript);
                    }
                });

                setTimeout(() => {
                    AOS.init({ once: true });
                    AOS.refresh();
                }, 100);
            });

        return () => {
            // Cleanup added styles and scripts
            document.querySelectorAll(".fetched-style, .fetched-script").forEach(el => el.remove());
        };
    }, []);

    // JS-based chevron toggle — runs after HTML is rendered into the DOM
    useEffect(() => {
        if (!html) return;
        const handlers = [];
        document.querySelectorAll(".gw-embed-wrapper .accordion-button").forEach((btn) => {
            const handler = () => {
                requestAnimationFrame(() => {
                    const chevron = btn.querySelector(".sidebar-chevron-wrap");
                    if (!chevron) return;
                    chevron.style.transform = btn.classList.contains("collapsed")
                        ? "rotate(0deg)"
                        : "rotate(180deg)";
                });
            };
            btn.addEventListener("click", handler);
            handlers.push({ btn, handler });
        });
        return () => {
            handlers.forEach(({ btn, handler }) => btn.removeEventListener("click", handler));
        };
    }, [html]);

    return (
        <div>
            <style>{`
                .gw-embed-wrapper {
                    overflow-x: clip;
                    width: 100%;
                }
                /* Reset section styles bleeding from main-demo.css */
                .gw-embed-wrapper section {
                    padding: initial;
                    margin: initial;
                    width: auto;
                    max-width: none;
                }
                /* Fix chatbot intro rows collapsing due to fetched CSS media query at 1400px */
                @media (min-width: 769px) {
                    .gw-embed-wrapper #page-chatbot .cb-introduce-row {
                        flex-direction: column !important;
                    }
                    .gw-embed-wrapper #page-chatbot .cb-introduce-row-2 {
                        flex-direction: column !important;
                    }
                }
                .gw-embed-wrapper .cb-intro-box {
                    min-width: 0;
                }
                /* Reset accordion styles bleeding from style-demo.css / sidebar.css */
                .gw-embed-wrapper .accordion-item {
                    background: transparent;
                    border: var(--bs-accordion-border-width, 1px) solid var(--bs-accordion-border-color, rgba(0,0,0,.125));
                    border-radius: 0;
                    transition: none;
                }
                .gw-embed-wrapper .accordion-item:not(:last-of-type) {
                    padding-bottom: 0;
                }
                .gw-embed-wrapper .accordion-body {
                    padding: 1rem 1.25rem;
                    background-color: var(--bs-accordion-bg, #fff);
                }
                .gw-embed-wrapper .accordion-button {
                    padding: 1rem 1.25rem;
                    background-color: var(--bs-accordion-btn-bg, #fff);
                    color: var(--bs-accordion-btn-color, #212529);
                    font-weight: inherit;
                }
                .gw-embed-wrapper .accordion-button.collapsed {
                    background-color: var(--bs-accordion-btn-bg, #fff);
                    color: var(--bs-accordion-btn-color, #212529);
                }
                /* Hide default Bootstrap ::after chevron — using inline SVG instead */
                .gw-embed-wrapper .accordion-button::after {
                    display: none !important;
                }
                /* Rotate inline SVG chevron on open/close */
                .gw-embed-wrapper .accordion-button:not(.collapsed) .sidebar-chevron-wrap {
                    transform: rotate(180deg) !important;
                }
                .gw-embed-wrapper img {
                    max-width: 100%;
                    height: auto;
                }
                .gw-sidebar {
                    width: 23% !important;
                    top: 90px !important;
                }
                /* Restore padding for chatbot inner sections only (not outer page-section containers) */
                .gw-embed-wrapper .cb-block {
                    padding: 60px 0;
                }
                .gw-embed-wrapper #cb-usage, .gw-embed-wrapper #cb-qa {
                    padding: 30px 0 !important;
                }
                .gw-embed-wrapper .cb-vector img {
                    width: auto;
                }
            `}</style>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <div className="gw-embed-wrapper" dangerouslySetInnerHTML={{ __html: html }} />
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default CloudGroupware;
